// extracted by mini-css-extract-plugin
export default {"outlook":"index_outlook__3dRAK"};